// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"3e356ae0","839":"c47debb0"}[chunkId] + ".chunk.js";
};